export default function MySQL_WEEKDAY() {
  return (
    <div>
      <h2>MySQL_WEEKDAY</h2>    </div>
  );
}